import React from 'react'
import { Rule } from './types'
import {
  AsyncSelectInput,
  RadioInput,
  SelectInput,
  TextInput,
} from '@demandlocal/components'
import { match, P } from 'ts-pattern'

const ValueSelector = ({
  rule,
  ruleBaseName,
  index,
}: {
  rule: Rule
  ruleBaseName
  index: number
}): React.ReactNode => {
  return match(rule)
    .with({ valueType: 'radio' }, (r) => (
      <div className={'w-full bg-red-50'}>
        <RadioInput options={r.radioOptions} name={`${ruleBaseName}.value`} />
      </div>
    ))
    .with({ valueType: 'select' }, (r) => (
      <SelectInput
        name={`${ruleBaseName}.value`}
        options={r.options}
        isLoading={false}
        placeholder="Select a value"
      />
    ))
    .with({ valueType: 'multi-select' }, (r) => (
      <SelectInput
        name={`${ruleBaseName}.value`}
        options={r.options}
        isLoading={false}
        placeholder="Select a value"
        isMulti
        isClearable
      />
    ))
    .with({ valueType: 'async-select' }, (r) => (
      <AsyncSelectInput
        fetchFn={r.useOptionsHook!}
        labelKeyName={r.labelKeyName}
        valueKeyName={r.valueKeyName}
        searchKeyName={r.searchKeyName}
        name={`${ruleBaseName}.value`}
        placeholder="Select a value"
      />
    ))
    .with({ valueType: 'async-multi-select' }, (r) => (
      <AsyncSelectInput
        fetchFn={r.useOptionsHook!}
        labelKeyName={r.labelKeyName}
        valueKeyName={r.valueKeyName}
        searchKeyName={r.searchKeyName}
        name={`${ruleBaseName}.value`}
        isMulti
        isClearable
        placeholder="Select a value"
      />
    ))
    .with({ valueType: 'date' }, (r) => (
      <TextInput name={`${ruleBaseName}.value`} label={''} type={'date'} />
    ))
    .with({ valueType: 'text' }, (r) => (
      <TextInput name={`${ruleBaseName}.value`} label={''} type={'text'} />
    ))
    .with({ valueType: 'number' }, (r) => (
      <TextInput name={`${ruleBaseName}.value`} label={''} type={'number'} />
    ))
    .exhaustive()
}

export default ValueSelector
